// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"125":"534a6669ceed1925a1df","293":"bf449f86bfca253ff771","385":"f5d7303ca484abe6b210"}[chunkId] + ".js";
};